import script from "./OrderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderModal.vue?vue&type=style&index=0&id=d24e9896&lang=css"

const __exports__ = script;

export default __exports__